/* global twttr */
import React            from 'react'
import { XmlEntities }  from 'html-entities'
import classNames       from 'classnames'
import AnchorLink       from '../../../common/AnchorLink'

const entities        = new XmlEntities()

class Commentary extends React.Component {

  constructor(props) {
    super(props)
    this.state = {
      tab       : 'all', // all, key
      displayQuantity : 3
    }
  }

  componentDidMount() {
    try{
      /* Check for instance of tweet code in tweet and action if exists. */
      var myJs = document.getElementById('twitter-wjs')
      if ( myJs == null ) {
        var js = document.createElement('script')
        js.id = 'twitter-wjs'
        js.src = '//platform.twitter.com/widgets.js'
        document.getElementsByTagName('head')[0].appendChild(js)
      } else {
        twttr.widgets.load()
      }
    } catch(e) {
      // no empties...
    }
  }

  componentDidUpdate() {
    try {
      // Load Twitter widgets upon component update
      twttr.widgets.load()
    } catch(e) {
      // no empties...
    }
  }

  swapTab( sView ) {   
    if ( sView === 'all' || sView === 'key' ) {
      this.setState( { tab: sView } )
    }
  }

  render() {

    const aEvents     = this.props.events || []
    const hText       = this.props.text || {}
    const link        = this.props.link || {}
    const sport       = this.props.sport || ''
    const bShowAll    = (this.props.showAll === true) ? true : false

    let iEventLen     = aEvents.length
    let aEventsList   = []
    let rHeader       = null
    let rSubHeader    = null
    let rFooter       = null
    let sViewName     = hText[ 'viewAll' ] || ''

    let tryId     = 1
    
    if ( iEventLen === 0 ) {
      return null
    }

    if ( !bShowAll && iEventLen > this.state.displayQuantity ) {
      iEventLen = this.state.displayQuantity
    }

    for (let i = 0; i < iEventLen; i++) {
      const oEvent  = aEvents[i]
      const props = {
        type    : oEvent.type,
        text    : oEvent.text,
        time    : oEvent.time,
        homeScore : oEvent.homeScore,
        awayScore : oEvent.awayScore,
        sport   : sport
      }

      if ( this.state.tab !== 'all' ) {
        if( sport == 'rugby-league' ) {
          if(oEvent.type == 24 || oEvent.type == 26) {
            tryId = oEvent.type
          }
        }
        if ( oEvent.type == tryId || oEvent.type == 2 || oEvent.type == 3 || oEvent.type == 4 || oEvent.type == 5 || oEvent.type == 6 || oEvent.type == 14 ) {
          aEventsList.push(
            <CommentaryRow key={i} {...props} />
          )
        }
      } else {
        aEventsList.push(
          <CommentaryRow key={i} {...props} />
        )
      }
    }

    if ( bShowAll ) {
      
      let aAllBtnClass = [ 'button-filter-alt', 'lg', 'fixed' ]
      let aKeyBtnClass = [ 'button-filter-alt', 'lg', 'fixed' ]
      
      if ( this.state.tab === 'all' ) {
        aAllBtnClass.push('active')
      } else {
        aKeyBtnClass.push('active')
        sViewName = hText['viewKey'] || ''
      }

      rHeader = (
        <header>
          <div className="button-group" data-behavior="tabs">
            <a className={ classNames(aAllBtnClass) } onClick={this.swapTab.bind(this,'all')}>{ hText['allBtn'] || '' }</a>
            <a className={ classNames(aKeyBtnClass) } onClick={this.swapTab.bind(this,'key')}>{ hText['keyBtn'] || '' }</a>
          </div>
        </header>
      )

      rSubHeader = (
        <header>
          <h1>{sViewName}</h1>
        </header>
      )

    } else {
      rHeader = (
        <header>
          <h1 style={ { textAlign: 'left' } }>{sViewName}</h1>
        </header>
      )
      rFooter = (
        <footer>
          <AnchorLink {...link}/>
        </footer>
      )
    }

    return (
      <article className="sub-module match-commentary" data-behavior="accordion">
        {rHeader}
        <div className="content">
          <div id="tab1">
            {rSubHeader}
            <table>
              <tbody>
                {aEventsList}
              </tbody>
            </table>
          </div>
        </div>
        {rFooter}
      </article>
    )
  }
}

const CommentaryRow = ({
  type        = 0,
  text        = '',
  time        = '',
  homeScore   = 0,
  awayScore   = 0, 
  sport       = ''
}) => {

  let bShowScore  = false
  let aIconClass  = [ 'game-icon', 'icon-font-before' ]

  let subOnId   = 8
  let subOffId  = 7
  let tryId     = 1

  if( sport == 'rugby-league' ) {
    subOffId = 17  
    if(type == 24 || type == 26) {
      tryId = type
    }
  }
  
  if (type == tryId || type == 14 ) {
    //try or penalty try
    bShowScore  = true
    aIconClass.push('icon-rugby-solid-before')
  } else if ( type == 2 ) {
    //conversion
    bShowScore  = true
    aIconClass.push('icon-rugby-conversion-solid-before')
  } else if ( type == 3 ) {
    //penalty kick
    bShowScore  = true
    aIconClass.push('icon-rugby-penalty-solid-before')
  } else if ( type == 4 ) {
    //drop goal
    bShowScore  = true
    aIconClass.push('icon-rugby-drop-goal-solid-before')
  } else if ( type == 5 ) {
    //yellow
    aIconClass.push('icon-soccer-card02-solid-before')
    aIconClass.push('icon-yellowcard')
  } else if ( type == 6 ) {
    aIconClass.push('icon-soccer-card02-solid-before')
    aIconClass.push('icon-redcard')
  } else if (type == subOffId || type == subOnId ) {
    aIconClass.push('icon-soccer-substitution-before')
  } else if (type == 9 || type == 10 || type == 11 || type == 12 || type == 13) {
    bShowScore  = true
    aIconClass.push('icon-soccer-foul-solid-before')
  }

  /* TODO hide icon on mobile so tweets fit properly */
  
  /* decode back to normal HTML */
  text = entities.decode(text) //'('+type+') '+

  if ( bShowScore ) {
    text = '<span class="current-score">'+homeScore+'-'+awayScore+'</span> '+text
  }

  return (
    <tr>
      <td className="time-stamp">{time}</td>
      <td className={ classNames(aIconClass) }></td>
      <td className="game-details" dangerouslySetInnerHTML={ { __html: text } }></td>
    </tr>
  )

}

export default Commentary



/** WEBPACK FOOTER **
 ** ../app/components/gamepackage/rugby/components/Commentary.jsx
 **/